module.exports = __webpack_public_path__ + "static/media/hyundai-pin.a0077829.svg";